import PropTypes from 'prop-types'
import React, { Fragment } from 'react'
import { StyledButton as Button } from '../../../common/Button'
import Menu from '../../../common/Menu'
import ImageBlockOptionsContainer from './ImageBlockOptionsContainer'
import SourceButton from './SourceButton'
import BlockName from './BlockName'

export const ImageBlockOptions = ({
  block,
  src,
  originalSource,
  t,
  upload,
  crop,
  removeContent
}) => (
  <Fragment>
    {/* Name */}
    <BlockName>{block.name || t('blockOptions.defaultImageName')}</BlockName>

    {/* {!!block.filesize && (
        <FormElement>
          <Text grey small bold>
            {t('blockOptions.size', { bytes: block.filesize })}
          </Text>
        </FormElement>
      )} */}

    {/* Crop */}
    <Button onClick={crop}>{t('blockOptions.crop')}</Button>

    {/* Replace */}
    <Button Component="label" htmlFor="block-upload">
      {t('blockOptions.replace')}
    </Button>
    <input
      type="file"
      id="block-upload"
      accept="image/*"
      style={{ display: 'none' }}
      onChange={e => upload(e)}
    />

    {/* Remove */}
    <Button onClick={removeContent}>{t('blockOptions.remove')}</Button>

    {/* Download */}
    <Button href={src} target="_blank">
      {t('blockOptions.download')}
    </Button>

    {/* Source */}
    {originalSource && <SourceButton source={originalSource} />}

    <Menu.Divider />
  </Fragment>
)

ImageBlockOptions.propTypes = {
  block: PropTypes.object
}

export default ImageBlockOptionsContainer(ImageBlockOptions)
